<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="KZGComponent.pkid > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="500px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="KZGComponent"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <el-form-item label="件号">
          <el-input v-model="KZGComponent.partNo" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="外部件号">
          <el-input v-model="KZGComponent.wbpartNo" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model="KZGComponent.partName" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="客户名称">
          <el-input v-model="KZGComponent.customer" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="生产线">
          <el-input v-model="KZGComponent.productionWorkLine" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="工序">
          <el-input v-model="KZGComponent.productionWorkLineProcess" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="KZGComponent.statusText" clearable placeholder="请选择">
            <el-option
                v-for="item in constants.statusText.$options"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constants from "../../../util/constants";

  export default {
    name:"KZGComponentEdit",
    components: {},
    data() {
      return {
        constants,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        parentNameList: [],
        KZGComponent: {
          addCompanyID: "",
          addDate: "",
          bookerID: "",
          bookerName: "",
          customer: "",
          ownerID: "",
          ownerName: "",
          partName: "",
          partNo: "",
          pkid: "",
          productionWorkLine: "",
          productionWorkLineProcess: "",
          status: "",
          statusText: "",
          updateDate: "",
          wbpartNo: "",
        },
        ruleValidate: {
          districtName: {required: true, message: "不能为空",trigger: "blur"},
          note: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        this.KZGComponent.pkid = id;
        this.dialogVisible = true;
        if(id>0) {
          this.getData();
        }else {
          this.getNote();
        }
      },
      getData() {
        this.$http
          .get("basic", `kZGKeyParts/${this.KZGComponent.pkid}`)
          .then(resp => {
            this.KZGComponent = resp;
          });
      },
      getNote() {
        this.$http
          .get("basic", "kZGKeyParts")
          .then(resp => {
            this.KZGComponent = resp;
          });
      },
      handleSubmit() {
        if(this.KZGComponent.pkid>0) {
          this.handleSubmitUpData();
        }else {
          this.handleSubmitSave();
        }
      },
      handleSubmitUpData() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "kZGKeyParts", this.KZGComponent)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSubmitSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "kZGKeyParts", this.KZGComponent)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
